export default __webpack_public_path__ + "static/media/a3.77c67814.png";